import { Injectable, computed, signal } from '@angular/core';

/**
 * Conta le richieste HTTP verso il backend attualmente in volo.
 * Alimentato dal `coldStartInterceptorFn`; letto dal `BackendLoadingComponent`
 * per mostrare la barra di caricamento e l'avviso di cold-start Cloud Run.
 */
@Injectable({ providedIn: 'root' })
export class BackendStatusService {
  private readonly _pending = signal(0);

  /** True finché c'è almeno una richiesta al backend in corso. */
  readonly active = computed(() => this._pending() > 0);

  begin(): void {
    this._pending.update((n) => n + 1);
  }

  end(): void {
    this._pending.update((n) => Math.max(0, n - 1));
  }
}
